var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28 28)",
    id: "e37dba53-f17e-444f-89e7-2b773adc3040"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillOpacity: 0,
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -28,
    y: -28,
    rx: 0,
    ry: 0,
    width: 56,
    height: 56
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(Infinity NaN NaN Infinity 0 0)",
    id: "3626c36b-6f5c-4ce5-8bd1-4b6c1f932cc9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 28 28)",
    id: "d332ddf6-afe9-4145-9aed-65ae1a05ad19"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAYAAAAe2bNZAAAAAXNSR0IArs4c6QAABPBJREFUWEedWF1S20gQ/kbgfcV524qoWnOCxQewMSeAnCBwAjy5QMgFIjhBnBPEnCDGPkDMCdZUodS+rfy6gHqr50+j8chWdp6wGLU+dX/z9dcS+MWVpaNjUHkGQSN9qzgG0AVQALRUl0jMIJI7mc/075ZLtNmX9UZd/FteQeACQK/NPWbPCoQJfktu5WpW7LpvJ5jPh8MrQbg2b8/x1gCmAM0g9vhhBWdAAX4u/9HJwh2IjgHxhwFQEDD+kM+/bgPUCMYE/w6Ay8DrHkQ38udi2hQwOxxOQTgD6FLmi0n2dnAOIcYATsw9S3SS06YsRcEoXqBkIMyFNUBjDr4rzVk6uADEF86MfJqf2/0GFN9/oLmVnMb4tAGmDkQ8oCNGberNDzYP/cZZlPncEFxD0pl+XZrSRQHVwJjS/GUyco9Ocr4NiNn/EWB+KLJoAAKf5NOceeZW9vuoh72SY9tVoJMc+fHrYNLhD8ORggSuxUtyJ/+erWLlMUB4f3i6vsp8zqeuAqLJrfmnyC16AP0JYCnzed9udGCydDAGRLb5YE3G8Hq1XzwYkgIvWMXAZ+ngu86aLruK9VzySx5YsuuEunqqFHYBkiblnPr36u9O8iYsV3Y4vAbhY6wktawcjkYglZU1OknPxsmq665cGowNHBAvS0+WKp0iOZVPs1ntIe5tScp8cRMrpY7twGySOh1yzBP7QhpMOuSs9ED0ztcRdx1J3x5Fcyq+GbKu8ZocN/EqAFPjR/C/lcznR8Ic5R8APcp84chYXQdkPve45Ui+BtHFNhH0KKD5IcQUJS399pClQ24TB0DSF16JbmU+Z7VUqybvdUVlHdmZkaCkWgyrVeA16XNGs3TIh+M9c1Vktm7mgfUgQ+bClbrGb0X0aH7XgDfxpRZL6czrCEjG5lgrCXCqDdxXYCIkDcjtx97QkjaAYoT2Cc5guNN28ZocNQqc6lU0MW/EMQsQ1Aki0PLDz8Xd/waj+yCLZ8FgiAP5JG0+pkZbNjesgORdGzPll8X2L4uBwTg2twpW6QZDugXo3DW/oNfEXipzLUfrk3dQ1js50xDQiRX2kxs8l+xxTthwyXxxuq1kNgtW1UPO6MCR09RYLm2anFUwHZn9LvuVJYidoFmB5czSwUpl0mqOUE2TG+u9rzOtT0jMtxiR5BdjQNWKGy1+kWApnanYLPP5m12nomZHA99iWgVziP3vyJy+zZ7EmrNfXoDAHdxY0qRvepNN3WZDDMF5ir1hjmoiF5Qyyj23R7eioGu3IaDKpC1HoxJnqVPvLXuMzzEZ9v2MaWYtslOVFtzgQkkwhGYh64ZOwGbI453zOTGntzX9LlgwlrjrvsWMGHPVEvQea+ackww8sDFTbfSiwelVFpMe0dk7jhn6SvjEg8zv7VymbWfwVpX32BeXTdOBZzvdjJSlJ1+MZqyBZBRT9GrPJtimuckStHEC9GquHJz3O86jevmiYLdNlBZQAaLL0NHVzVfSB0oWsl50ZtJHmM2VmVDjWdsxa9Ossg00I4iJP7xXxgxcWpb1mnX9/HZwJgR4BLKfT7ZOqDu/Qpj5iKdDK/MFIKYkaClIDXDOqoJwTQIrodWXZ23OBK9W8/pOMO4ovpRjNuDeZ45dnYOt1yOEmHBnbzOvtwJTO3EseKI8N32F/8VHk7PG323MlyqaAnuzNv7Ij/0f4n89afWZb7YAAAAASUVORK5CYII=",
    x: -17.5,
    y: -17.5,
    width: 35,
    height: 35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDef);
export default __webpack_public_path__ + "static/media/def.e62a947dda5eebeefcfcd3f574f07377.svg";
export { ForwardRef as ReactComponent };